import { SubmitHandler, useForm } from 'react-hook-form'
import { useEmployerInfoContext } from 'Contexts/EmployerInfoContext'
import { useCreateMetaFieldQuery } from 'Hooks/api/JOONAdmin/useCreateMetaFieldQuery'
import { useUpdateMetaFieldQuery } from 'Hooks/api/JOONAdmin/useUpdateMetaFieldQuery'
import { EmployerMetaField } from 'Services/employerService'

export type MetaFieldFormValues = {
  fieldName: string
  required: boolean
  unique: boolean
}

export const useMetaFieldForm = (closeModal: () => void, metaField: EmployerMetaField | null) => {
  const {
    state: { employerId }
  } = useEmployerInfoContext()

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid }
  } = useForm<MetaFieldFormValues>({
    mode: 'onChange',
    defaultValues: {
      fieldName: metaField?.fieldName ?? '',
      required: metaField?.required ?? false,
      unique: metaField?.unique ?? false
    }
  })

  const { mutateAsync: createMetaField, isLoading: isCreating } = useCreateMetaFieldQuery()
  const { mutateAsync: updateMetaField, isLoading: isUpdating } = useUpdateMetaFieldQuery()

  const handleSubmission: SubmitHandler<MetaFieldFormValues> = async (values) => {
    if (employerId === undefined) return

    const response = metaField
      ? await updateMetaField({ employerId, metaFieldId: metaField.id, ...values })
      : await createMetaField({ employerId, ...values })

    if (response.success) closeModal()
  }

  return {
    register,
    handleSubmit,
    handleSubmission,
    errors,
    canSubmit: isDirty && isValid,
    isLoading: isCreating || isUpdating
  }
}
